import { render, staticRenderFns } from "./NoticeEdit.vue?vue&type=template&id=4637f9c0&scoped=true"
import script from "./NoticeEdit.vue?vue&type=script&lang=js"
export * from "./NoticeEdit.vue?vue&type=script&lang=js"
import style0 from "./NoticeEdit.vue?vue&type=style&index=0&id=4637f9c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4637f9c0",
  null
  
)

export default component.exports